<template>
  <div class="columns is-vcentered is-mobile is-variable is-2">
    <div class="column is-narrow">
      <album-cover
        v-bind:album="this.track.album"
        v-bind:isSmall="true"
        v-on:click="$emit('cover-click')"
        class="track-cover is-64x64 poly-cursor-pointer"
      >
        <span v-if="isPlaying" class="state-icon icon is-medium has-text-black is-overlay poly-hidden poly-visible-touch">
          <i class="mdi mdi-pause"></i>
        </span>
        <span v-else class="state-icon icon is-medium has-text-black is-overlay poly-hidden poly-visible-touch">
          <i class="mdi mdi-play"></i>
        </span>
      </album-cover>
    </div>

    <div class="column poly-truncate">
      <dl>
        <dd class="track-name has-text-weight-bold poly-truncate">
          <router-link v-bind:to="{ name: 'album', params: { id: track.album.id } }">{{ track.name }}</router-link>
        </dd>
        <dd class="track-artist has-text-grey-light has-text-weight-semibold">
          <ul class="track-artists poly-truncate">
            <li
              v-for="(artist, index) in track.artists"
              v-bind:key="artist.id"
            >
              <span v-if="index > 0">, </span>
              <router-link v-bind:to="{ name: 'artist', params: { id: artist.id } }" class="has-text-grey-light">{{ artist.name }}</router-link>
            </li> -
            <router-link v-bind:to="{ name: 'album', params: { id: track.album.id } }" class="has-text-grey-light">{{ track.album.name }}</router-link>
          </ul>
        </dd>
      </dl>
    </div>

    <!-- TODO: Add duration of the track (the computed function has been created already) -->
  </div>
</template>

<script>
  import AlbumCover from '@/components/AlbumCover'

  const formatDuration = require('format-duration')

  export default  {
    name: 'PlayerQueueTrack',
    props: {
      track: {
        type: Object,
        required: true
      }
    },
    components: {
      AlbumCover
    },
    computed: {
      isPlaying: function () {
        return(
          this.$store.getters.isPlaying &&
          this.$store.getters.currentTrack &&
          this.$store.getters.currentTrack.id === this.track.id
        )
      },
      duration: function () {
        return formatDuration(this.track.duration * 1000)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  .track-cover .state-icon {
    margin: auto;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 100%;
    border: 1px solid $white-ter;
  }
  .track-cover:hover .state-icon { visibility: visible; }
  .track-artists li { display: inline; }
  .track-artists {
    font-size: 0.85rem;
    margin-top: -0.16rem;
  }

  // Mobile specific modifiers
  @media (max-width: $tablet - 1) {
    .track-name { font-size: 0.9rem; }
    .track-cover .state-icon { transform: scale(1.0); }
  }
</style>
